export const formatBankNumber = (inputNumber) => {
  const cleanedNumber = inputNumber.replace(/[^0-9]/g, '');
  let formatted = '';

  const hyphenPositions = [2, 6, 13];
  for (let i = 0; i < cleanedNumber.length; i++) {
    if (hyphenPositions.includes(i) && cleanedNumber[i] !== '-') {
      formatted += '-';
    }
    formatted += cleanedNumber[i];
  }
  return formatted;
};
